export default __webpack_public_path__ + "assets/front/scss/affichage-timeline.6fa302b1d181a6ab5c9671aa79efcebd.css";